export default __webpack_public_path__ + "static/media/ProductSans-Thin.7b8334be.eot";